<template>
  <div class="form_add_page">
    <div class="top-container flex_between">
      <div class="flex_center" style="cursor: pointer" @click="back">
        <i class="el-icon-arrow-left" />
        <div class="split"></div>
        {{ $t("home.applyClaim") }}
      </div>
      <div>
        <el-button
          class="primary-btn"
          size="small"
          type="primary"
          @click="back"
          >{{ $t("operate.backList") }}</el-button
        >
      </div>
    </div>
    <div class="form_info">
      <el-form :inline="true" :model="addForm" :rules="rules" ref="form">
        <!-- 车辆基本信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("seek.basic") }}
          </div>
        </div>
        <div class="form-container">
          <!-- VIN -->
          <el-form-item :label="$t('seek.vin')" prop="vin">
            <!-- <el-input
              v-model="addForm.vin"
              :placeholder="$t('placeholder.enter')"
              @change="getECPDataByVIN"
            ></el-input> -->
            <el-select
              v-model="addForm.vin"
              @change="changeVin"
              filterable clearable
              remote
              reserve-keyword
              placeholder=""
              :remote-method="remoteMethod"
              :loading="loading"
            >
              <el-option
                v-for="item in options"
                :key="item.vin"
                :label="item.vin"
                :value="item.vin"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 品牌 -->
          <el-form-item :label="$t('home.brand')" prop="carBrand">
            <el-input
              v-model="addForm.carBrand"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 车型 -->
          <el-form-item :label="$t('home.carType')" prop="carModel">
            <el-input
              v-model="addForm.carModel"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 车辆属性 -->
          <el-form-item :label="$t('climant.carAttribute')" prop="carAttribute">
            <el-select v-model="addForm.carAttribute" filterable clearable>
              <el-option :label="$t('climant.ryc')" :value="0"> </el-option>
              <el-option :label="$t('climant.ddc')" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 发动机号 -->
          <el-form-item
            :label="$t('seek.engineNUmber')"
            :prop="addForm.carAttribute === 0 ? 'engineNumber' : ''"
          >
            <el-input
              v-model="addForm.engineNumber"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 发动机/电机型号 -->
          <el-form-item
            :label="$t('seek.engineModel')"
            :prop="addForm.carAttribute === 0 ? 'engineModel' : ''"
          >
            <el-input
              v-model="addForm.engineModel"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 电机号 -->
          <el-form-item
            :label="$t('climant.djNumer')"
            :prop="addForm.carAttribute === 1 ? 'motorModel' : ''"
          >
            <el-input
              v-model="addForm.motorModel"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 行驶里程 -->
          <el-form-item :label="$t('seek.distance')" prop="roadHaul">
            <el-input-number
              class="number-input"
              v-model="addForm.roadHaul"
              :controls="false"
              :precision="0"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-append">km</div>
            <!-- <el-input
              v-model="addForm.roadHaul"
              :placeholder="$t('placeholder.enter')"
            >
              <template slot="append">KM</template>
            </el-input> -->
          </el-form-item>
          <!-- 生产日期 -->
          <el-form-item :label="$t('seek.produceDate')" prop="productionDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.productionDate"
              :placeholder="$t('placeholder.select')"
            ></el-date-picker>
          </el-form-item>
          <!-- 购车日期 -->
          <el-form-item :label="$t('seek.buyDate')" prop="salesDate">
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.salesDate"
              :placeholder="$t('placeholder.select')"
            ></el-date-picker>
          </el-form-item>
          <!-- 零部件专业 -->
          <el-form-item :label="$t('climant.partMajor')" v-show="addForm.lbjzy">
            <el-select disabled v-model="addForm.lbjzy" placeholder=" " filterable clearable>
              <el-option :label="$t('climant.carBody')" :value="1"> </el-option>
              <el-option :label="$t('climant.chassis')" :value="2"> </el-option>
              <el-option :label="$t('climant.electricalAppliances')" :value="3">
              </el-option>
              <el-option
                :label="$t('climant.interiorAndExteriorDecoration')"
                :value="4"
              >
              </el-option>
              <el-option :label="$t('climant.newEnergy')" :value="5">
              </el-option>
              <el-option :label="$t('climant.power')" :value="6"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 车辆故障信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.hitchInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 发生日期 -->
          <el-form-item
            class="err-nowarp"
            :label="$t('seek.happenDate')"
            prop="happenDate"
          >
            <el-date-picker
              type="date"
              value-format="yyyy-MM-dd"
              v-model="addForm.happenDate"
              :placeholder="$t('placeholder.select')"
              @change="getPreSetData"
            ></el-date-picker>
          </el-form-item>
          <!-- 问题类别 -->
          <el-form-item :label="$t('seek.wtlb')" prop="questionType">
            <el-select v-model="addForm.questionType" @change="changeQuestionType" filterable clearable>
              <el-option :label="$t('seek.khPDI')" value="客户PDI"> </el-option>
              <el-option :label="$t('seek.zdkh')" value="终端客户"> </el-option>
<!--              <el-option :label="$t('seek.gkjy')" value="港口救援"> </el-option>-->
            </el-select>
          </el-form-item>
          <!-- 维修方案 -->
<!--          <el-form-item :label="$t('climant.wxfa')" prop="repairPlan">-->
<!--            <el-select @change="changeScheme" v-model="addForm.repairPlan" filterable clearable>-->
<!--              <el-option :label="$t('climant.wx')" :value="0"> </el-option>-->
<!--              <el-option :label="$t('climant.gh')" :value="1"> </el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <!-- 故障现象 -->
          <div>
            <el-form-item :label="$t('climant.hitchAppearance')" prop="symptom">
              <el-input
                type="textarea"
                v-model="addForm.symptom"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障初步原因 -->
          <div>
            <el-form-item
              :label="$t('climant.hitchReson')"
              prop="preliminaryCauseOfFailure"
            >
              <el-input
                type="textarea"
                v-model="addForm.preliminaryCauseOfFailure"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <!-- 故障处理方案 -->
          <div>
            <el-form-item
              :label="$t('climant.hitchPlan')"
              prop="processingScenarios"
            >
              <el-input
                type="textarea"
                v-model="addForm.processingScenarios"
                style="width: 680px"
                :placeholder="$t('placeholder.enter')"
                maxlength="1000"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <!-- 故障件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.gzjxxl") }}
          </div>
        </div>
        <!-- 主因故障件 -->
        <div class="second-title">{{ $t("climant.mainFault") }}</div>
        <div class="form-container">
          <!-- 故障件件号 -->
          <el-form-item
            class="err-nowarp"
            :label="$t('climant.faultNo')"
            prop="faultPartNumber"
          >
            <el-autocomplete
              :disabled="!(addForm.currency === 1 || addForm.currency === 0)"
              ref="autocomplete"
              v-model="addForm.faultPartNumber"
              :placeholder="$t('placeholder.enter')"
              :fetch-suggestions="getFaultList"
              @select="handleSelect($event)"
              @keyup.enter.native="handleInput('autocomplete')"
              @blur="onBlurFault()"
            ></el-autocomplete>
          </el-form-item>
          <!-- 故障件名称 -->
          <el-form-item :label="$t('climant.faultName')" prop="faultPartName">
            <el-input v-model="addForm.faultPartName" disabled></el-input>
          </el-form-item>
          <!-- 故障件单价 -->
          <el-form-item
            :label="$t('climant.faultPrice')"
            prop="faultPartUnitPrice"
          >
            <el-input-number
              disabled
              class="prepend-input"
              v-model="addForm.faultPartUnitPrice"
              :controls="false"
              :precision="2"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 零部件来源 -->
          <el-form-item
            :label="$t('climant.unitSource')"
            prop="sourceOfComponents"
          >
            <el-select
              v-model="addForm.sourceOfComponents"
              @change="changesourceOfComponents('')"
              filterable clearable
            >
              <el-option :label="$t('climant.mfj')" :value="0"> </el-option>
              <el-option :label="$t('climant.gysmfj')" :value="2"> </el-option>
              <el-option :label="$t('climant.sfj')" :value="1"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 更换数量  -->
          <el-form-item :label="$t('climant.changeNum')" prop="changeQuantity">
            <el-input-number
              :controls="false"
              :precision="0"
              v-model="addForm.changeQuantity"
              :placeholder="$t('placeholder.enter')"
              @change="getTotalPrice('fault')"
            ></el-input-number>
          </el-form-item>
          <!-- 维修方案 -->
          <el-form-item :label="$t('climant.wxfa')" prop="repairPlan">
            <el-select
              @change="changeScheme"
              v-model="addForm.repairPlan"
              filterable clearable
            >
              <el-option :label="$t('climant.wx')" :value="0"> </el-option>
              <el-option :label="$t('climant.gh')" :value="1"> </el-option>
              <el-option :label="$t('claimantKd.bf')" :value="2"> </el-option>
            </el-select>
          </el-form-item>
          <!-- 工时 -->
          <el-form-item :label="$t('climant.manHour')" prop="workingHours">
            <el-input-number
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              v-model="addForm.workingHours"
              :placeholder="$t('placeholder.enter')"
              @change="getTotalPrice('fault')"
            ></el-input-number>
          </el-form-item>
          <!-- 运费 -->
          <el-form-item :label="$t('climant.transportationCost')" prop="shippingFee">
            <el-input-number
              :controls="false"
              :precision="2"
              v-model="addForm.shippingFee"
              :placeholder="$t('placeholder.enter')"
              @change="getTotalPrice('fault')"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 关税 -->
          <el-form-item :label="$t('climant.customs')" prop="tariff">
            <el-input-number
              :controls="false"
              :precision="2"
              v-model="addForm.tariff"
              :placeholder="$t('placeholder.enter')"
              @change="getTotalPrice('fault')"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他费用 -->
          <el-form-item :label="$t('climant.otherCost')" prop="otherExpenses">
            <el-input-number
              :controls="false"
              :precision="2"
              v-model="addForm.otherExpenses"
              :placeholder="$t('placeholder.enter')"
              @change="getTotalPrice('fault')"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 管理费费率 -->
          <el-form-item
            :label="$t('climant.manageRate')"
            prop="managementFeeRate"
          >
            <el-input v-model="addForm.managementFeeRate" disabled></el-input>
          </el-form-item>
          <!-- 工时费用 -->
          <el-form-item :label="$t('claimantKd.gsfy')" prop="laborCost">
            <el-input-number
              disabled
              v-model="addForm.laborCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料费用 -->
          <el-form-item :label="$t('claimantKd.clfy')" prop="materialCost">
            <el-input-number
              disabled
              v-model="addForm.materialCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 故障件总金额 -->
          <el-form-item
            :label="$t('climant.faultTotalPrice')"
            prop="faultPartTotalPrice"
          >
            <el-input-number
              disabled
              v-model="addForm.faultPartTotalPrice"
              :controls="false"
              :precision="2"
              class="prepend-input"
            >
            </el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他故障件 -->
        </div>
        <div class="second-title">
          {{ $t("climant.otherFault") }}
          <div
            v-if="showfaultListError"
            class="is-error"
            style="margin-left: 37px"
          >
            {{ $t("climant.faultError") }}
          </div>
        </div>
        <div class="table-container" style="padding: 0 18px 0 54px">
          <div class="table-btn" style="margin: 15px 0">
            <el-button
              :disabled="tableData.length >= 20"
              type="primary"
              class="primary-btn"
              size="small"
              @click="handleAddFault"
              >{{ $t("home.add") }}</el-button
            >
          </div>
          <el-table
            ref="tableRef"
            :data="tableData"
            stripe
            border
            highlight-current-row
          >
            <!-- 序号 -->
            <el-table-column
              type="index"
              :label="$t('cart.xh')"
              width="60"
              align="center"
              :render-header="$globalRenderHeader"
            >
            </el-table-column>
            <!-- 故障件件号 -->
            <el-table-column
              prop="faultPartNumber"
              :label="$t('climant.faultNo')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-autocomplete
                  :disabled="
                    !(addForm.currency === 1 || addForm.currency === 0)
                  "
                  :class="scope.row.error ? 'is-error' : ''"
                  size="mini"
                  :ref="'autocomplete' + scope.$index"
                  v-model="scope.row.faultPartNumber"
                  :placeholder="$t('placeholder.enter')"
                  :fetch-suggestions="getFaultList"
                  @select="handleSelect($event, scope.$index)"
                  @keyup.enter.native="
                    handleInput('autocomplete' + scope.$index)
                  "
                  @blur="onBlurFault(scope.$index)"
                ></el-autocomplete>
              </template>
            </el-table-column>
            <!-- 故障件名称 -->
            <el-table-column
              prop="faultPartName"
              :label="$t('climant.faultName')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-input
                  :disabled="faultPartNameDisabled[scope.$index]"
                  size="mini"
                  v-model="scope.row.faultPartName"
                  @blur="
                    getFaultPartNameZh(scope.row.faultPartName, scope.$index)
                  "
                ></el-input>
              </template>
            </el-table-column>
            <!-- 故障件单价 -->
            <el-table-column
              prop="faultPartUnitPrice"
              :label="$t('climant.faultPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    :disabled="faultPartNameDisabled[scope.$index]"
                    v-model="scope.row.faultPartUnitPrice"
                    class="prepend-input"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 零部件来源 -->
            <el-table-column
              prop="sourceOfComponents"
              :label="$t('climant.unitSource')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.sourceOfComponents"
                  @change="getTotalPrice('fault', scope.$index)"
                  filterable clearable
                >
                  <el-option :label="$t('climant.mfj')" :value="0"> </el-option>
                  <el-option :label="$t('climant.gysmfj')" :value="2"> </el-option>
                  <el-option :label="$t('climant.sfj')" :value="1"> </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 更换数量 -->
            <el-table-column
              prop="changeQuantity"
              :label="$t('climant.changeNum')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    :controls="false"
                    :precision="0"
                    v-model="scope.row.changeQuantity"
                    :placeholder="$t('placeholder.enter')"
                    @change="getTotalPrice('fault', scope.$index)"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 维修方案 -->
            <el-table-column
              :label="$t('climant.wxfa')"
              prop="repairPlan"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-select
                  filterable clearable
                  @change="changeScheme(scope)"
                  v-model="scope.row.repairPlan"
                >
                  <el-option :label="$t('climant.wx')" :value="0"> </el-option>
                  <el-option :label="$t('climant.gh')" :value="1"> </el-option>
                  <el-option :label="$t('claimantKd.bf')" :value="2">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <!-- 工时 -->
            <el-table-column
              prop="workingHours"
              :label="$t('climant.manHour')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :min="0"
                    :max="999"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.workingHours"
                  ></el-input-number>
                </div>
              </template>
            </el-table-column>
            <!-- 运费 -->
            <el-table-column
              prop="shippingFee"
              :label="$t('climant.transportationCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.shippingFee"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 关税 -->
            <el-table-column
              prop="tariff"
              :label="$t('climant.customs')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.tariff"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 其他费用 -->
            <el-table-column
              prop="otherExpenses"
              :label="$t('climant.otherCost')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    :controls="false"
                    :precision="2"
                    size="mini"
                    @change="getTotalPrice('fault', scope.$index)"
                    v-model="scope.row.otherExpenses"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 管理费费率 -->
            <el-table-column
              prop="managementFeeRate"
              :label="$t('climant.manageRate')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-input
                  size="mini"
                  disabled
                  v-model="scope.row.managementFeeRate"
                ></el-input>
              </template>
            </el-table-column>
            <!-- 工时费用 -->
            <el-table-column
              prop="laborCost"
              :label="$t('claimantKd.gsfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.laborCost"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 材料费用 -->
            <el-table-column
              prop="materialCost"
              :label="$t('claimantKd.clfy')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.materialCost"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- 故障件总金额 -->
            <el-table-column
              prop="faultPartTotalPrice"
              :label="$t('climant.faultTotalPrice')"
              align="center"
              min-width="160px"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <div class="table-number-input">
                  <el-input-number
                    size="mini"
                    disabled
                    v-model="scope.row.faultPartTotalPrice"
                    :controls="false"
                    :precision="2"
                    class="prepend-input"
                  ></el-input-number>
                  <div class="number-input-prepend">
                    {{ addForm.currency === 0 ? "￥" : "" }}
                    {{ addForm.currency === 1 ? "$" : "" }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column
              prop="id"
              :label="$t('cart.operate')"
              align="center"
              :render-header="$globalRenderHeader"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleDeleteFault(scope.$index)"
                >
                  {{ $t("cart.delete") }}</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 费用信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("climant.costInfo") }}
          </div>
        </div>
        <div class="form-container">
          <!-- 总工时 -->
          <el-form-item :label="$t('claimantKd.zgs') + '(h)'" prop="manHour">
            <el-input-number
              v-model="addForm.manHour"
              :controls="false"
              :min="0"
              :max="999"
              :precision="2"
              disabled
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
          </el-form-item>
          <!-- 工时单价 -->
          <el-form-item :label="$t('climant.hourlyPrice')" prop="hourlyRate">
            <el-input-number
              disabled
              v-model="addForm.hourlyRate"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 工时总费用 -->
          <el-form-item
            :label="$t('claimantKd.gszfy')"
            prop="totalCostOfWork"
          >
            <el-input-number
              disabled
              v-model="addForm.totalCostOfWork"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 材料总费用 -->
          <el-form-item
            :label="$t('claimantKd.clzfy')"
            prop="materialTotalCost"
          >
            <el-input-number
              disabled
              v-model="addForm.materialTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>

          <!-- 总运费 -->
          <el-form-item :label="$t('claimantKd.zyf')" prop="freight">
            <el-input-number
              v-model="addForm.freight"
              :controls="false"
              :precision="2"
              disabled
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 总关税 -->
          <el-form-item :label="$t('claimantKd.zguanshui')" prop="tariffTotal">
            <el-input-number
              v-model="addForm.tariffTotal"
              :controls="false"
              :precision="2"
              disabled
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他总费用 -->
          <el-form-item :label="$t('claimantKd.qtzfy')" prop="otherTotalCost">
            <el-input-number
              disabled
              v-model="addForm.otherTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
              :placeholder="$t('placeholder.enter')"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 其他总费用说明 -->
          <el-form-item
            :label="$t('climant.otherCostCondition')"
            prop="otherInstruction"
          >
            <el-input
              v-model="addForm.otherInstruction"
              :placeholder="$t('placeholder.enter')"
            ></el-input>
          </el-form-item>
          <!-- 索赔总费用 -->
          <el-form-item
            :label="$t('climant.climantTotal')"
            prop="claimTotalCost"
          >
            <el-input-number
              disabled
              v-model="addForm.claimTotalCost"
              :controls="false"
              :precision="2"
              class="prepend-input"
            ></el-input-number>
            <div class="number-input-prepend">
              {{ addForm.currency === 0 ? "￥" : "" }}
              {{ addForm.currency === 1 ? "$" : "" }}
            </div>
          </el-form-item>
          <!-- 结算币种 -->
          <el-form-item :label="$t('climant.currency')" prop="currency">
            <el-select disabled v-model="addForm.currency" filterable clearable>
              <el-option label="CNY" :value="0"> </el-option>
              <el-option label="USD" :value="1"> </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 附件信息 -->
        <div class="hearder-title">
          <div class="flex_between">
            <img
              class="title-icon"
              src="@/assets/img/title-icon.svg"
              alt="dark"
            />
            {{ $t("home.attachmentInfo") }}
          </div>
        </div>
        <div class="form-container">
          <el-form-item :label="$t('seek.appendix')" prop="fileList" required>
            <drag-upload
              ref="uploadFile"
              :accessoryList.sync="addForm.fileList"
              :httpRequest="action"
            />
            <!-- <el-upload
              class="upload-demo"
              ref="uploadFile"
              drag
              :headers="header"
              :action="action"
              :on-success="handleFileSuccess"
              :before-upload="beforeFileUpload"
              :on-remove="handleRemoveFile"
              :on-change="handleChange"
              multiple
              :file-list="newFileList"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">{{ $t("seek.dragFile") }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <div class="tips">
              <p>{{ $t("seek.formats") }}：</p>
              <p>1.{{ $t("seek.img") }}：jpg、png、jpeg、svg</p>
              <span>{{ $t("seek.limit10") }}</span>
              <p>2.{{ $t("seek.video") }}：mp4 、3gp、mov、m4v</p>
              <span>{{ $t("seek.limit100") }}</span>
              <p>3.{{ $t("seek.table") }}：xlsx</p>
              <span>{{ $t("seek.limit20") }}</span>
              <p>4.{{ $t("seek.doc") }}：doc、docx、pdf</p>
              <span>{{ $t("seek.limitDoc20") }}</span>
              <p>2.{{ $t("seek.zip") }}：zip 、rar、7z</p>
              <span>{{ $t("seek.limitZip100") }}</span>
              <p>{{ $t("seek.appendixTotal") }}</p>
            </div>-->
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="flex_default_center">
      <el-button
        size="small"
        class="primary-btn"
        type="primary"
        :loading="saveLoading"
        @click="handleSaveAndCommit"
      >
        {{ $t("climant.saveCommit") }}
      </el-button>
      <el-button
        size="small"
        class="primary-btn"
        type="primary"
        :loading="saveLoading"
        @click="handleSave"
      >
        {{ $t("climant.save") }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { totalSum } from "@/util/totalSum";
import { uploadUrl } from "@/util/url";
import {
  newClaimant,
  editClaimant,
  deleteFile,
  getPreset,
  getECPData,
  getECPDataByVIN,
  checkWarrantyTime,
} from "@/api/seek";
import CryptoJS from "crypto-js";
import { getStorage, getSession } from "@/util/localStor";
import { getDictItem, getDictValue } from "@/util/dict";

export default {
  data() {
    return {
      saveLoading: false, // 保存按钮点击状态
      faultList: [], // EPC系统故障件数据
      tableData: [], // 其他故障件
      faultError: false, // 主因故障件错误
      showfaultListError: false, // 其他故障件错误
      happenDateError: false, // 发生日期错误
      faultPartNameDisabled: [], // 故障件名称禁用状态
      addForm: {
        totalCostOfWork: 0,
        materialTotalCost: 0,
        freight: 0,
        tariff: 0,
        tariffTotal: 0,
        otherTotalCost: 0,
        claimTotalCost: 0,
        travelPriceTotal: 0,
        otherExpenses: 0,
        materialCost: 0,
        faultPartTotalPrice: 0,
        workingHours: 0,
        changeQuantity: 0,
        shippingFee: 0,
        laborCost: 0,
      }, // 表单数据
      // upLoadFiles: [], // 上传文件
      // uploading: false, // 上传状态
      // header: {
      //   satoken: sessionStorage.getItem("satoken"),
      // }, // 上传
      action: "/customer/claim/upload", // 上传
      // fileList: [], // 上传
      // newFileList: [],
      // max: 500, // 上传
      // sum: 0, // 上传
      exchangeRate: "1",
      loading: false,
      options: [],
      list: [],
      oldSum: null, //总价
    };
  },
  watch: {
    // 语言切换时，清空表单验证
    "$i18n.locale": function (item) {
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
  },
  computed: {
    // 表单验证规则放在computed，防止语言切换时，验证提醒没有实时切换
    rules() {
      return {
        sourceOfComponents: [{ required: true, message: this.$t(" ") }],
        vin: [{ required: true, message: this.$t(" ") }],
        carBrand: [{ required: true, message: this.$t(" ") }],
        carModel: [{ required: true, message: this.$t(" ") }],
        carAttribute: [{ required: true, message: this.$t(" ") }],
        engineNumber: [{ required: true, message: this.$t(" ") }],
        engineModel: [{ required: true, message: this.$t(" ") }],
        motorModel: [{ required: true, message: this.$t(" ") }],
        roadHaul: [{ required: true, message: this.$t(" ") }],
        productionDate: [{ required: true, message: this.$t(" ") }],
        salesDate: [{ required: this.addForm.questionType !== '客户PDI', validator: this.validateSalesDate, trigger: "change" }],
        happenDate: [
          { required: true, message: this.$t(" ") },
          { validator: this.validateHappenDate },
        ],
        questionType: [{ required: true, message: this.$t(" ") }],
        repairPlan: [{ required: true, message: this.$t(" ") }],
        symptom: [{ required: true, message: this.$t(" ") }],
        preliminaryCauseOfFailure: [{ required: true, message: this.$t(" ") }],
        processingScenarios: [{ required: true, message: this.$t(" ") }],
        faultPartNumber: [
          { required: true, message: this.$t(" ") },
          { validator: this.validateFaultPartNumber, trigger: "blur" },
        ],
        faultPartName: [{ required: true, message: this.$t(" ") }],
        faultPartUnitPrice: [{ required: true, message: this.$t(" ") }],
        managementFeeRate: [{ required: true, message: this.$t(" ") }],
        changeQuantity: [
          { required: true, message: this.$t(" ") },
          { validator: this.validateChangeQuantity, trigger: "change" },
        ],
        faultPartTotalPrice: [{ required: true, message: this.$t(" ") }],
        manHour: [{ required: true, message: this.$t(" ") }],
        hourlyRate: [{ required: true, message: this.$t(" ") }],
        totalCostOfWork: [{ required: true, message: this.$t(" ") }],
        // materialTotalCost: [{ required: true, message: this.$t(" ") }],
        freight: [{ required: true, message: this.$t(" ") }],
        tariff: [{ required: true, message: this.$t(" ") }],
        claimTotalCost: [{ required: true, message: this.$t(" ") }],
        currency: [{ required: true, message: this.$t(" ") }],
        fileList: [
          { required: true, message: "请上传附件", trigger: "change" },
        ],
      };
    },
  },
  created() {},
  mounted() {
    this.addForm = getStorage("claimantData") || {};
    // this.addForm.totalCostOfWork = this.addForm.totalCostOfWork ?? 0;
    // // this.addForm.materialTotalCost = this.addForm.materialTotalCost ?? 0;
    // this.addForm.freight = this.addForm.freight ?? 0;
    // this.addForm.tariffTotal = this.addForm.tariffTotal ?? 0;
    // this.addForm.otherTotalCost = this.addForm.otherTotalCost ?? 0;
    // this.addForm.claimTotalCost = this.addForm.claimTotalCost ?? 0;
    this.addForm.changeQuantity = this.addForm.changeQuantity ?? 0;
    // this.addForm.travelPriceTotal = this.addForm.travelPriceTotal ?? 0;
    this.addForm.otherExpenses = this.addForm.otherExpenses ?? 0;
    // this.addForm.materialCost = this.addForm.materialCost ?? 0;
    // // this.addForm.faultPartTotalPrice = this.addForm.faultPartTotalPrice ?? 0;
    this.addForm.workingHours = this.addForm.workingHours ?? 0;
    this.addForm.shippingFee = this.addForm.shippingFee ?? 0;
    // this.addForm.laborCost = this.addForm.laborCost  ?? 0;
    this.addForm.tariff = this.addForm.tariff  ?? 0;
    console.log(this.addForm);
    this.oldSum = this.addForm.claimTotalCost
      ? this.addForm.claimTotalCost
      : null; //总价有值,保存下来
    this.tableData = this.addForm.faultPartsList || [];
    if (!(JSON.stringify(this.addForm) === "{}")) {
      if (this.addForm.repairPlan == 0) {
        // this.addForm.sourceOfComponents = 0;
        // this.addForm.changeQuantity = 0;
        this.tableData?.map((item, index) => {
          // item.sourceOfComponents = 0;
          // item.changeQuantity = 0;
          this.getTotalPrice("fault", index);
        });
        this.$set(
          this.addForm,
          "totalCostOfWork",
          this.addForm.manHour * this.addForm.hourlyRate
        );
        this.getTotalPrice("fault");
      }
    }
    this.addForm.claimTotalCost = this.oldSum ? this.oldSum : undefined; //总价有值重新赋值，没值计算
    // this.addForm.fileList?.map((item, index) => {
    //   this.fileList.push({
    //     ...item,
    //     name: item.fileName,
    //     url: encodeURI(item.filePath),
    //   });
    // });
    // this.newFileList = [...this.fileList];

    this.getExchangeRate();
  },
  methods: {
    // 改变维修方案
    changeScheme(val) {
      // if (val == 0) {
      //   // this.addForm.sourceOfComponents = 0;
      //   // this.addForm.changeQuantity = 0;
        this.tableData?.map((item, index) => {
          // item.sourceOfComponents = 0;
          // item.changeQuantity = 0;
          this.getTotalPrice("fault", index);
        });
      // }
      this.getTotalPrice("fault");
    },
    // 改变问题类别
    changeQuestionType() {
      this.$nextTick(() => {
        this.$refs.form.validateField("salesDate");
      });
    },
    // 改变零部件来源
    changesourceOfComponents(val) {
      // let msg = "";
      // if (val) {
      //   this.getTotalPrice("fault", val.$index);
      //   // if (val.row.sourceOfComponents == 1) {
      //   //   msg = this.$t("climant.selfFunded");
      //   // } else {
      //   //   msg = this.$t("climant.free");
      //   // }
      // } else {
      //   this.getTotalPrice("fault");
      //   // if (this.addForm.sourceOfComponents == 1) {
      //   //   msg = this.$t("climant.selfFunded");
      //   // } else {
      //   //   msg = this.$t("climant.free");
      //   // }
      // }
      // this.$notify.info({
      //   message: msg,
      //   offset: 100,
      //   duration: 2000,
      // });
      this.getTotalPrice("fault");
    },
    // 获取汇率
    async getExchangeRate() {
      const exchangeRateDict = await getDictItem("exchangeRate");
      const exchangeRateItem = getDictValue(exchangeRateDict, "USD/CNY");
      this.exchangeRate = exchangeRateItem?.codeText || this.exchangeRate;
    },
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 根据发生日期获取预设数据
    async getPreSetData() {
      const res = await getPreset({
        data: { happenDate: this.addForm.happenDate },
      });
      if (res.data) {
        this.$set(
          this.addForm,
          "managementFeeRate",
          res.data.claimManagementRate
        );
        this.$set(this.addForm, "hourlyRate", res.data.claimUnitPrice);
        this.$set(this.addForm, "currency", res.data.currency);
        if (
          (this.addForm.faultPartUnitPrice === 0 ||
            this.addForm.faultPartUnitPrice) &&
          (this.addForm.changeQuantity === 0 || this.addForm.changeQuantity) &&
          (this.addForm.managementFeeRate === 0 ||
            this.addForm.managementFeeRate)
        ) {
          this.$set(
            this.addForm,
            "faultPartTotalPrice",
            this.addForm.faultPartUnitPrice *
              this.addForm.changeQuantity *
              (1 + this.addForm.managementFeeRate)
          );
        }
        this.tableData?.map((item, index) => {
          this.tableData[index].managementFeeRate =
            this.addForm.managementFeeRate;
          if (
            (this.tableData[index].faultPartUnitPrice === 0 ||
              this.tableData[index].faultPartUnitPrice) &&
            (this.tableData[index].changeQuantity === 0 ||
              this.tableData[index].changeQuantity) &&
            (this.tableData[index].managementFeeRate === 0 ||
              this.tableData[index].managementFeeRate)
          ) {
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].faultPartUnitPrice *
              this.tableData[index].changeQuantity *
              (1 + this.tableData[index].managementFeeRate);
          }
        });
        // 材料总费用根据结算币种转换CNY
        if (this.addForm.faultPartTotalPrice) {
          if (this.addForm?.sourceOfComponents == 1) {
            var total = this.addForm.faultPartTotalPrice;
          } else {
            var total = 0;
          }

          this.tableData?.map((item) => {
            if (item.sourceOfComponents == 1) {
              total += item.faultPartTotalPrice ? item.faultPartTotalPrice : 0;
            }
          });
          this.addForm.materialTotalCost = total;
        }
        this.getTotalPrice("costOfWork");
        this.happenDateError = false;
      } else {
        this.$set(this.addForm, "managementFeeRate", undefined);
        this.$set(this.addForm, "hourlyRate", undefined);
        this.$set(this.addForm, "currency", undefined);
        this.$set(this.addForm, "faultPartTotalPrice", undefined);
        this.$set(this.addForm, "materialTotalCost", undefined);
        this.tableData?.map((item, index) => {
          this.tableData[index].managementFeeRate = undefined;
          this.tableData[index].faultPartTotalPrice = undefined;
        });
        this.happenDateError = true;
      }
      this.$refs.form.validateField("happenDate");
    },
    // 校验发生日期
    async validateHappenDate(rule, value, callback) {
      if (this.happenDateError) {
        callback(new Error(this.$t("climant.preSetError")));
      } else {
        callback();
      }
    },
    // 校验购车日期
    async validateSalesDate(rule, value, callback) {
      if (this.addForm.questionType === "客户PDI") {
        callback();
      } else {
        if (!value) {
          callback(new Error(this.$t(" ")));
        } else {
          callback();
        }
      }
    },
    // 校验更换数量
    async validateChangeQuantity(rule, value, callback) {
      if (this.addForm.repairPlan != 0) {
        callback();
      } else {
        if (!value || value <= 0 || !Number.isInteger(value)) {
          callback(new Error(this.$t(" ")));
        } else {
          callback();
        }
      }
    },
    // 判断ECP数据中是否存在该故障件
    async findFault() {
      const faultIndex = this.faultList.findIndex((item) => {
        return item.code === this.addForm.faultPartNumber;
      });
      if (faultIndex === -1) {
        this.$set(this.addForm, "faultPartName", "");
        this.$set(this.addForm, "faultPartNameZh", "");
        this.$set(this.addForm, "faultPartUnitPrice", "");
        this.getTotalPrice("fault");
        this.faultError = true;
      } else {
        this.$set(
          this.addForm,
          "faultPartName",
          this.faultList[faultIndex][this.$i18n.locale] ||
            this.faultList[faultIndex].en ||
            this.faultList[faultIndex].zh
        );
        this.$set(
          this.addForm,
          "faultPartNameZh",
          this.faultList[faultIndex].zh
        );
        this.$set(
          this.addForm,
          "faultPartUnitPrice",
          this.addForm.currency === 0
            ? (this.faultList[faultIndex].price * this.exchangeRate).toFixed(2)
            : this.faultList[faultIndex].price
        );
        this.getTotalPrice("fault");
        this.faultError = false;
      }
    },
    // 校验故障件件号
    validateFaultPartNumber(rule, value, callback) {
      if (this.faultError) {
        callback(new Error(this.$t("climant.faultError")));
      } else {
        callback();
      }
    },
    // 获取ECP接口参数
    getECPParams() {
      const appId = "586738eb-49ed-4289-b951-193bfee3452b";
      const authToken = "298714f9-b43c-4772-b259-e6e2728cbd91";
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now.getDate().toString().padStart(2, "0");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const timestamp =
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds;
      // 拼接appId、authToken和timestamp三个参数后，进行MD5摘要得到16进制摘要字符串，然后转大写得到签名
      const concat = appId + authToken + timestamp;
      const sign = CryptoJS.MD5(concat).toString().toUpperCase();
      return { appId, timestamp, sign };
    },
    // 根据故障件件号，EPC系统获取故障件
    async getFault(queryString) {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        codeList: [queryString],
        account: getSession("person").customerAccountNum,
      };
      const res = await getECPData(params);
      const faultList = res.data;
      return faultList;
    },
    // 获取故障件列表
    async getFaultList(queryString, cb) {
      if (queryString && queryString.length >= 7) {
        const faultList = await this.getFault(queryString);
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      } else {
        this.faultList = [];
      }
      cb(this.faultList);
    },
    // 输入故障件
    handleInput(ref) {
      this.$refs[ref].$refs.input.blur(); // 取消焦点
      this.$refs[ref].activated = false; // 关闭下拉框
    },
    // 表格输入故障件获取数据
    async onBlurFault(index) {
      if (index === 0 || index) {
        this.$set(this.faultPartNameDisabled, index, true);
      }
      if (this.faultList.length === 0) {
        const faultList = await this.getFault(
          index === 0 || index
            ? this.tableData[index].faultPartNumber
            : this.addForm.faultPartNumber
        );
        this.faultList = [];
        faultList?.map((item) => {
          this.faultList.push({ ...item, zh: item.name, value: item.code });
        });
      }

      if (index === 0 || index) {
        if (!this.tableData[index].faultPartNumber) {
          this.tableData[index].error = undefined;
        } else {
          const faultIndex = this.faultList.findIndex((item) => {
            return item.code === this.tableData[index].faultPartNumber;
          });
          if (faultIndex === -1) {
            this.tableData[index].faultPartName = "";
            this.tableData[index].faultPartNameZh = "";
            this.tableData[index].faultPartUnitPrice = "";
            this.$set(this.tableData[index], "error", true);
            this.getTotalPrice("fault", index);
            this.$set(this.faultPartNameDisabled, index, false);
          } else {
            this.tableData[index].faultPartName =
              this.faultList[faultIndex][this.$i18n.locale] ||
              this.faultList[faultIndex].en ||
              this.faultList[faultIndex].zh;
            this.tableData[index].faultPartNameZh =
              this.faultList[faultIndex].zh;
            this.tableData[index].faultPartUnitPrice =
              this.addForm.currency === 0
                ? (
                    this.faultList[faultIndex].price * this.exchangeRate
                  ).toFixed(2)
                : this.faultList[faultIndex].price;
            this.tableData[index].error = undefined;
            this.getTotalPrice("fault", index);
          }
        }
        this.showfaultListError =
          this.tableData.findIndex((item) => {
            return item.error === true;
          }) !== -1;
      } else {
        await this.findFault();
        this.$refs.form.validateField("faultPartNumber");
      }
    },
    // 选择故障件
    handleSelect(item, index) {
      this.$set(this.faultPartNameDisabled, index, true);
      if (index === 0 || index) {
        this.tableData[index].faultPartName =
          item[this.$i18n.locale] || item.en || item.zh;
        this.tableData[index].faultPartNameZh = item.zh;
        this.tableData[index].faultPartUnitPrice =
          this.addForm.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price;
        this.tableData[index].error = undefined;
        this.getTotalPrice("fault", index);
        this.showfaultListError =
          this.tableData.findIndex((item) => {
            return item.error === true;
          }) !== -1;
      } else {
        this.$set(
          this.addForm,
          "faultPartName",
          item[this.$i18n.locale] || item.en || item.zh
        );
        this.$set(this.addForm, "faultPartNameZh", item.zh);
        this.$set(
          this.addForm,
          "faultPartUnitPrice",
          this.addForm.currency === 0
            ? (item.price * this.exchangeRate).toFixed(2)
            : item.price
        );
        this.getTotalPrice("fault");
        this.faultError = false;
      }
    },
    // 获取故障件总金额
    getTotalPrice(type, index) {
      if (type === "fault") {
        if (index === 0 || index) {
          // 维修工时不*数量
          // 为空则赋值0
          this.tableData[index].workingHours =
            this.tableData[index].workingHours || 0;
          this.tableData[index].changeQuantity =
            this.tableData[index].changeQuantity || 0;

          if (this.tableData[index].repairPlan == 0 ){
            const rawCost =  this.tableData[index].workingHours *
            this.addForm.hourlyRate
            this.tableData[index].laborCost = Math.round( rawCost + 'e' + 2) / 100
          } else {
            const rawCost =this.tableData[index].workingHours *
              this.addForm.hourlyRate *
              this.tableData[index].changeQuantity
            this.tableData[index].laborCost =   Math.round( rawCost + 'e' + 2) / 100
          }

          // 材料费计算 维修方案是维修 或者不是收费件时价格为0
            if (
              this.tableData[index].repairPlan == 0 ||
              this.tableData[index].sourceOfComponents != 1
            ) {
              this.tableData[index].materialCost = 0;
            } else {
              const rawCost = this.tableData[index].faultPartUnitPrice *
                this.tableData[index].changeQuantity *
                (1 + this.tableData[index].managementFeeRate)
              this.tableData[index].materialCost =  Math.round( rawCost + 'e' + 2) / 100
            }

          if (
            (this.tableData[index].laborCost == 0 ||
              this.tableData[index].laborCost) &&
            (this.tableData[index].materialCost == 0 ||
              this.tableData[index].materialCost) &&
            (this.tableData[index].shippingFee == 0 ||
              this.tableData[index].shippingFee) &&
            (this.tableData[index].tariff == 0 || this.tableData[index].tariff)
          ) {
            this.tableData[index].faultPartTotalPrice =
              this.tableData[index].laborCost +
              this.tableData[index].materialCost +
              this.tableData[index].shippingFee +
              this.tableData[index].tariff +
              (this.tableData[index].otherExpenses || 0);
          } else {
            this.tableData[index].faultPartTotalPrice = 0;
          }
        } else
        {
          // 维修方案为0 维修时，工时费为工时*工时费单价
          if (this.addForm.repairPlan == 0){
            const rawCost = this.addForm.workingHours *
              this.addForm.hourlyRate
            this.addForm.laborCost = Math.round( rawCost + 'e' + 2) / 100
          }else {
            // 维修方案不为0 更换或者补发时，工时费为工时*工时费单价*更换数量
            const rawCost = this.addForm.workingHours *
              this.addForm.hourlyRate *
              this.addForm.changeQuantity
            this.addForm.laborCost = Math.round( rawCost + 'e' + 2) / 100
          }

          //
          if (
            (this.addForm.faultPartUnitPrice == 0 ||
              this.addForm.faultPartUnitPrice) &&
            (this.addForm.changeQuantity == 0 || this.addForm.changeQuantity) &&
            (this.addForm.managementFeeRate == 0 ||
              this.addForm.managementFeeRate)
          ) {
            if (
              this.addForm.repairPlan == 0 ||
              this.addForm.sourceOfComponents != 1
            ) {
              this.addForm.materialCost = 0;
            } else {
              const rawCost = this.addForm.faultPartUnitPrice *
                this.addForm.changeQuantity *
                (1 + this.addForm.managementFeeRate)
              this.addForm.materialCost = Math.round( rawCost + 'e' + 2) / 100
            }
          } else {
            this.addForm.materialCost = 0;
          }
          // 如果关税不填则为0
          this.addForm.tariff = this.addForm.tariff || 0;

          // if (
          //   (this.addForm.laborCost == 0 || this.addForm.laborCost) &&
          //   (this.addForm.materialCost == 0 || this.addForm.materialCost) &&
          //   (this.addForm.shippingFee == 0 || this.addForm.shippingFee) &&
          //   (this.addForm.tariff == 0 || this.addForm.tariff) &&
          //   (this.addForm.workingHours == 0 || this.addForm.workingHours)
          // ) {

            this.$set(
              this.addForm,
              "faultPartTotalPrice",
              this.addForm.laborCost +
                this.addForm.materialCost +
                this.addForm.shippingFee +
                this.addForm.tariff +
                (this.addForm.otherExpenses || 0)
            );
          // } else {
          //   this.$set(this.addForm, "faultPartTotalPrice", 0);
          // }
        }

        if (this.tableData.length > 0 || this.addForm.faultPartTotalPrice) {
          let materialTotal = 0;
          let workingHoursTotal = 0;
          let laborCostTotal = 0;
          let freightTotal = 0;
          let tariffTotal = 0;
          let otherTotal = 0;
          let workingHourArr = [];

          if (this.addForm.faultPartTotalPrice) {
            if(this.addForm.repairPlan == 0){
              workingHourArr.push(
                (this.addForm.workingHours || 0)
              );
            } else {
              workingHourArr.push(
                (this.addForm.workingHours || 0) *
                (this.addForm.changeQuantity || 0)
              );
            }
            materialTotal += this.addForm.materialCost
              ? this.addForm.materialCost
              : 0;
            laborCostTotal += this.addForm.laborCost
              ? this.addForm.laborCost
              : 0;
            freightTotal += this.addForm.shippingFee
              ? this.addForm.shippingFee
              : 0;
            tariffTotal += this.addForm.tariff ? this.addForm.tariff : 0;
            otherTotal += this.addForm.otherExpenses
              ? this.addForm.otherExpenses
              : 0;
          }

          this.tableData?.map((item) => {
            let newWorkingHours = 0;
            if (item.repairPlan == 0){
               newWorkingHours = item.workingHours;
            } else {
               newWorkingHours = item.workingHours * item.changeQuantity;
            }
            workingHourArr.push(newWorkingHours);
            materialTotal += item.materialCost ? item.materialCost : 0;
            laborCostTotal += item.laborCost ? item.laborCost : 0;
            freightTotal += item.shippingFee ? item.shippingFee : 0;
            tariffTotal += item.tariff ? item.tariff : 0;
            otherTotal += item.otherExpenses ? item.otherExpenses : 0;
          });
          workingHoursTotal = workingHourArr.reduce(
            (accumulator, currentValue) => accumulator + currentValue,
            0
          );
          this.$set(this.addForm, "materialTotalCost", materialTotal);
          this.$set(this.addForm, "manHour", workingHoursTotal);
          this.$set(this.addForm, "totalCostOfWork", laborCostTotal);
          this.$set(this.addForm, "freight", freightTotal);
          this.$set(this.addForm, "tariffTotal", tariffTotal);
          this.$set(this.addForm, "otherTotalCost", otherTotal);
        } else {
          this.$set(this.addForm, "materialTotalCost", 0);
          this.$set(this.addForm, "manHour", 0);
          this.$set(this.addForm, "totalCostOfWork", 0);
          this.$set(this.addForm, "freight", 0);
          this.$set(this.addForm, "tariff", 0);
          this.$set(this.addForm, "otherTotalCost", 0);
        }

        // 索赔总费用 = 工时总费用 + 材料总费用 + 其他费用 + 运费 +关税
        if (
          (this.addForm.totalCostOfWork || this.addForm.totalCostOfWork == 0) &&
          (this.addForm.materialTotalCost ||
            this.addForm.materialTotalCost == 0) &&
          (this.addForm.freight || this.addForm.freight == 0) &&
          (this.addForm.tariffTotal || this.addForm.tariffTotal == 0)
        ) {
          this.$set(
            this.addForm,
            "claimTotalCost",
            this.addForm.totalCostOfWork +
              this.addForm.materialTotalCost +
              (this.addForm.otherTotalCost || 0) +
              this.addForm.freight +
              this.addForm.tariffTotal
          );
        } else {
          this.$set(this.addForm, "claimTotalCost", 0);
        }
      }
    },
    // 根据vin获取ECP数据
    async getECPDataByVIN() {
      const { appId, timestamp, sign } = this.getECPParams();
      const params = {
        appId,
        timestamp,
        sign,
        vin: this.addForm.vin,
        account: getSession("person").customerAccountNum,
      };
      const res = await getECPDataByVIN(params);
      // 需判断返回的data是数组还是对象 arr instanceof Array / obj instanceof Object
      if (res.data) {
        this.$set(this.addForm, "carBrand", res.data[0]?.brand);
        this.$set(this.addForm, "carModel", res.data[0]?.model);
        this.$set(this.addForm, "engineModel", res.data[0]?.engineModel);
        this.$set(this.addForm, "productionDate", res.data[0]?.vinCreated);
      }
    },

    async remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        const { appId, timestamp, sign } = this.getECPParams();
        const params = {
          appId,
          timestamp,
          sign,
          vin: query,
          account: getSession("person").customerAccountNum,
        };
        const res = await getECPDataByVIN(params);
        if (res.data) {
          this.loading = false;
          this.options = res.data;
          this.options?.map((item, i) => {
            if (item.vin == query) {
              this.$set(this.addForm, "carBrand", item.brand);
              this.$set(this.addForm, "carModel", item.model);
              this.$set(this.addForm, "engineModel", item.engineModel);
              this.$set(this.addForm, "productionDate", item.vinCreated);
            }
          });
        } else {
          this.loading = false;
          this.options = [];
          this.addForm.vin = query;
          this.$set(this.addForm, "carBrand", "");
          this.$set(this.addForm, "carModel", "");
          this.$set(this.addForm, "engineModel", "");
          this.$set(this.addForm, "productionDate", "");
        }
      } else {
        this.options = [];
        this.$set(this.addForm, "carBrand", "");
        this.$set(this.addForm, "carModel", "");
        this.$set(this.addForm, "engineModel", "");
        this.$set(this.addForm, "productionDate", "");
      }
    },
    changeVin(val) {
      this.options?.map((item, i) => {
        if (item.vin == val) {
          this.$set(this.addForm, "carBrand", item.brand);
          this.$set(this.addForm, "carModel", item.model);
          this.$set(this.addForm, "engineModel", item.engineModel);
          this.$set(this.addForm, "productionDate", item.vinCreated);
        }
      });
    },
    // 新增其他故障件
    handleAddFault() {
      if (this.addForm.repairPlan == 0) {
        this.tableData.push({
          faultPartNumber: "", // 故障件件号
          faultPartName: "", // 故障件名称
          faultPartNameZh: "", // 故障件名称中文
          faultPartUnitPrice: undefined, // 故障件单价
          changeQuantity: 1, // 更换数量
          repairPlan: 0, // 维修方案
          workingHours: 0, // 工时
          shippingFee: 0, // 运费
          tariff: 0, // 关税
          otherExpenses: 0, // 其他费用
          managementFeeRate: this.addForm.managementFeeRate, // 管理费费率
          laborCost: 0, // 工时费用
          materialCost: 0, // 材料费用
          faultPartTotalPrice: 0, // 故障件总金额
          sourceOfComponents: 0, // 零部件来源
        });
      } else {
        this.tableData.push({
          faultPartNumber: "", // 故障件件号
          faultPartName: "", // 故障件名称
          faultPartNameZh: "", // 故障件名称中文
          faultPartUnitPrice: 0, // 故障件单价
          changeQuantity: 0, // 更换数量
          repairPlan: 0, // 维修方案
          workingHours: 0, // 工时
          shippingFee: 0, // 运费
          tariff: 0, // 关税
          otherExpenses: 0, // 其他费用
          managementFeeRate: this.addForm.managementFeeRate, // 管理费费率
          laborCost: 0, // 工时费用
          materialCost: 0, // 材料费用
          faultPartTotalPrice: 0, // 故障件总金额
          sourceOfComponents: "", // 零部件来源
        });
      }
    },
    // 删除其他故障件
    handleDeleteFault(index) {
      this.tableData.splice(index, 1);
      this.getTotalPrice("fault");
    },
    // 删除上传文件
    // handleRemoveFile(file, fileList) {
    //   this.uploading = false;
    //   const uid = file.uploadFileId;
    //   // this.deleteUploadFile(file);
    //   this.fileList.forEach((pic, i) => {
    //     if (pic.uploadFileId == uid) {
    //       this.fileList.splice(i, 1);
    //     }
    //   });
    // },
    // 删除上传文件
    // async deleteUploadFile(data) {
    //   const query = {
    //     data: {
    //       uploadFileId: data.uploadFileId,
    //       filePath: data.filePath,
    //     },
    //   };
    //   const res = await deleteFile(query);
    // },
    // 上传
    // handleChange(file, fileList) {
    //   this.upLoadFiles = fileList;
    // },
    // 上传成功
    // handleFileSuccess(res, file) {
    //   // this.uploading = true
    //   if (res.status == 0) {
    //     const data = res.data;
    //     const obj = {
    //       uploadFileId: data.uploadFileId,
    //       // dataId: data.dataId,
    //       uploaderId: data.uploaderId,
    //       fileName: data.fileName,
    //       fileSize: data.fileSize,
    //       fileType: data.fileType,
    //       filePath: encodeURI(data.filePath),
    //       fileSource: data.fileSource,
    //       name: data.fileName,
    //       url: encodeURI(data.filePath),
    //     };
    //     this.fileList.push(obj);
    //     const total = totalSum(this.fileList, "fileSize");
    //     this.sum = total / 1024;

    //     if (this.upLoadFiles.length == this.fileList.length) {
    //       this.uploading = false;
    //     }
    //   } else {
    //     this.$DonMessage.error(res.message);
    //     const uid = file.uid; // 关键作用代码，去除文件列表失败文件
    //     const idx = this.$refs.uploadFile.uploadFiles.findIndex(
    //       (item) => item.uid === uid
    //     );
    //     this.$refs.uploadFile.uploadFiles.splice(idx, 1);
    //     if (this.upLoadFiles.length == this.fileList.length) {
    //       this.uploading = false;
    //     }
    //   }
    // },
    // 上传之前
    // beforeFileUpload(file) {
    //   this.uploading = true;
    //   let lang = "";
    //   const language = sessionStorage.getItem("lang");
    //   language == "zh"
    //     ? (lang = 0)
    //     : language == "en"
    //     ? (lang = 1)
    //     : language == "ru"
    //     ? (lang = 2)
    //     : (lang = 3);
    //   this.header.lang = lang;
    //   let total = 0;
    //   total = this.sum + file.size / 1024 / 1024;

    //   if (total >= this.max) {
    //     this.$DonMessage.warning(this.$t("home.fileSum"));
    //     this.uploading = false;
    //     return false;
    //   }
    //   const imgLt = 10;
    //   const videoLt = 100;
    //   const xlsLt = 20;
    //   const docLt = 20;
    //   const zipLt = 100;
    //   let limit = 0;
    //   let isLt = 0;
    //   // 图片
    //   const isJPG = file.type === "image/jpeg";
    //   const isPNG = file.type === "image/png";
    //   const isSvg = file.type === "image/svg+xml";
    //   let isImg = false;
    //   if (isJPG || isPNG || isSvg) {
    //     isImg = true;
    //   }
    //   if (isImg) {
    //     limit = imgLt;
    //     isLt = file.size / 1024 / 1024 < limit;
    //     if (!isLt) {
    //       this.uploading = false;
    //       this.$DonMessage.warning(this.$t("home.img10M"));
    //     }
    //     return isImg && isLt;
    //   }

    //   // 视频
    //   const isMP4 = file.type === "video/mp4";
    //   const is3GP = file.type === "video/3gpp";
    //   const isMOV = file.type === "video/quicktime";
    //   const isM4V = file.type === "";
    //   let isVideo = false;
    //   if (isMP4 || is3GP || isMOV) {
    //     isVideo = true;
    //   }
    //   if (isVideo) {
    //     limit = videoLt;
    //     isLt = file.size / 1024 / 1024 < limit;
    //     if (!isLt) {
    //       this.$DonMessage.warning(this.$t("home.video100M"));
    //       this.uploading = false;
    //     }
    //     return isVideo && isLt;
    //   }

    //   // 表格
    //   const isXLS =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    //   if (isXLS) {
    //     limit = xlsLt;
    //     isLt = file.size / 1024 / 1024 < limit;
    //     if (!isLt) {
    //       this.$DonMessage.warning(this.$t("home.xlsx20M"));
    //       this.uploading = false;
    //     }
    //     return isXLS && isLt;
    //   }

    //   // 文档
    //   const isDOC = file.type === "application/msword";
    //   const isDOCX =
    //     file.type ===
    //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    //   const isPDF = file.type === "application/pdf";
    //   let isFile = false;
    //   if (isDOC || isDOCX || isPDF) {
    //     isFile = true;
    //   }
    //   if (isFile) {
    //     limit = docLt;
    //     isLt = file.size / 1024 / 1024 < limit;
    //     if (!isLt) {
    //       this.$DonMessage.warning(this.$t("home.doc20M"));
    //       this.uploading = false;
    //     }
    //     return isFile && isLt;
    //   }

    //   // 压缩包
    //   const isZIP =
    //     file.type === "application/zip" ||
    //     file.name.endsWith(".zip") ||
    //     file.name.endsWith(".rar") ||
    //     file.name.endsWith(".7z");
    //   if (isZIP) {
    //     limit = zipLt;
    //     isLt = file.size / 1024 / 1024 < limit;
    //     if (!isLt) {
    //       this.$DonMessage.warning(this.$t("home.zip100M"));
    //       this.uploading = false;
    //     }
    //     return isZIP && isLt;
    //   }
    // },
    // 获取客户国家名称
    getCustomerCountryName() {
      const person = getSession("person");
      const nationList = Object.values(getSession("nationList"));
      if (person.customerCountry && nationList.length > 0) {
        const country = nationList.find(item => item.id === person.customerCountry);
        return country ? (this.$i18n.locale === "zh" ? country.name : country.enName) : null;
      }
      return null;
    },
    // 新增
    async add(status) {
      // 如果是提交( status=1)，先检查质保时间 和 质保公里数
      if (status === 1) {
        const countryName = this.getCustomerCountryName();
        try {
          const checkRes = await checkWarrantyTime({
            data: {
              carModel: this.addForm.carModel,
              countryName: countryName,
              salesDate: this.addForm.salesDate,
              mileage: this.addForm.roadHaul,
              languageType: this.$i18n.locale
            }
          });
          if (checkRes.status === "0" && checkRes.data) {
            await this.$confirm(
              checkRes.data,
              this.$t("request.tips"),
              {
                confirmButtonText: this.$t("seek.yes"),
                cancelButtonText: this.$t("seek.no"),
                type: "warning",
              }
            );
          }
        } catch (e) {
          if (e !== "cancel") {
            console.error("质保检查失败", e);
          } else {
            return;
          }
        }
      }

      const submitData = JSON.parse(JSON.stringify(this.addForm));
      // submitData.fileList = this.fileList;
      submitData.faultPartsList = [];
      this.tableData?.map((item) => {
        if (item.faultPartNumber) {
          submitData.faultPartsList.push(item);
        }
      });
      submitData.status = status;
      submitData.languageType = this.$i18n.locale;
      this.saveLoading = true;
      try {
        var res = {};
        if (submitData.claimStatementId) {
          res = await editClaimant({ data: submitData });
        } else {
          res = await newClaimant({ data: submitData });
        }
        if (res.status == 0) {
          this.saveLoading = false;
          this.$DonMessage.success(this.$t("message.czcg"));
          this.back();
        } else {
          this.saveLoading = false;
          this.$DonMessage.warning(res.message);
        }
      } catch (error) {
        this.saveLoading = false;
      }
    },
    // 保存并提交
    handleSaveAndCommit() {
      this.$refs.form.validate(async (valid) => {
        if (!this.getFileUploadTip()) {
          return;
        }
        // 问题类别 不是客户PDI 购车日期不能为空
        if (this.addForm.questionType !== "客户PDI" && this.addForm.salesDate == ''){
          this.$notify.error({
            message: this.$t("rules.purchaseDate"),
            offset: 100,
            duration: 2000,
          });
          return;
        }
        // if (!valid) {
        //   this.$nextTick(() => {
        //     const firstInvalidField = document.querySelector(".is-error");
        //     if (firstInvalidField) {
        //       firstInvalidField.scrollIntoView({ behavior: "smooth" });
        //     }
        //   });
        //   return;
        // }
        let canAdd = false;
        if (
          this.addForm.sourceOfComponents == undefined ||
          this.addForm.sourceOfComponents == null
        ) {
          this.$notify.error({
            message: this.$t("rules.source"),
            offset: 100,
            duration: 2000,
          });

          canAdd = true;
        }
        if (this.addForm.repairPlan != 0) {
          if (!this.addForm.changeQuantity || this.addForm.changeQuantity <= 0 || !Number.isInteger(this.addForm.changeQuantity)) {
            this.$notify.error({
              message: this.$t("message.quantityError"),
              offset: 100,
              duration: 2000,
            });
            canAdd = true;
          }
        }
        this.tableData?.map((item, index) => {
          if (
            item.sourceOfComponents == undefined ||
            item.sourceOfComponents == null
          ) {
            this.$notify.error({
              message: this.$t("rules.source"),
              offset: 100,
              duration: 2000,
            });

            canAdd = true;
          }
          if (this.addForm.repairPlan != 0) {
            if (!item.changeQuantity || item.changeQuantity <= 0 || !Number.isInteger(item.changeQuantity)) {
              this.$notify.error({
                message: this.$t("message.otherQuantityError"),
                offset: 100,
                duration: 2000,
              });
              canAdd = true;
            }
          }
        });
        if (!canAdd) this.add(1);
      });
    },
    // 保存为草稿
    handleSave() {
      this.$refs.form.validate(async (valid) => {
        // if (!valid) {
        //   this.$nextTick(() => {
        //     const firstInvalidField = document.querySelector(".is-error");
        //     if (firstInvalidField) {
        //       firstInvalidField.scrollIntoView({ behavior: "smooth" });
        //     }
        //   });
        //   return;
        // }
        // 问题类别 不是客户PDI 购车日期不能为空
        if (this.addForm.questionType !== "客户PDI" && this.addForm.salesDate == ''){
          this.$notify.error({
            message: this.$t("rules.purchaseDate"),
            offset: 100,
            duration: 2000,
          });
          return;
        }
        if (!this.getFileUploadTip()) {
          return;
        }
        let canAdd = false;
        if (
          this.addForm.sourceOfComponents == undefined ||
          this.addForm.sourceOfComponents == null
        ) {
          this.$notify.error({
            message: this.$t("rules.source"),
            offset: 100,
            duration: 2000,
          });

          canAdd = true;
        }
        if (this.addForm.repairPlan != 0) {
          if (!this.addForm.changeQuantity || this.addForm.changeQuantity <= 0 || !Number.isInteger(this.addForm.changeQuantity)) {
            this.$notify.error({
              message: this.$t("restock.quantityError"),
              offset: 100,
              duration: 2000,
            });
            canAdd = true;
          }
        }
        this.tableData?.map((item, index) => {
          if (
            item.sourceOfComponents == undefined ||
            item.sourceOfComponents == null
          ) {
            this.$notify.error({
              message: this.$t("rules.source"),
              offset: 100,
              duration: 2000,
            });

            canAdd = true;
          }
          if (this.addForm.repairPlan != 0) {
            if (!item.changeQuantity || item.changeQuantity <= 0 || !Number.isInteger(item.changeQuantity)) {
              this.$notify.error({
                message: this.$t("message.otherQuantityError"),
                offset: 100,
                duration: 2000,
              });
              canAdd = true;
            }
          }
        });
        if (!canAdd) this.add(0);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.form_add_page {
  padding: 0 !important;
  // padding-bottom: 20px;
  ::v-deep .el-input {
    // width: 250px;
  }
  ::v-deep .el-table__body .el-input {
    // width: unset;
  }
  // ::v-deep .el-textarea__inner {
  //   font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
  //     "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  // }
  .top-container {
    padding: 10px 32px 10px 14px;
    border-bottom: 5px solid #efefef;
    .split {
      margin: 0 10px 0 7px;
      border: 1px solid #dde0e8;
      height: 18px;
    }
  }
  .hearder-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title-icon {
      margin-right: 10px;
    }
    .flex_between{
      display: flex !important;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .form-container {
    margin-top: 34px;
    padding: 0 60px;
    .fileUpload {
        width: 500px;
      }
  }
  .second-title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #bd3124;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .tips {
    // line-height: 20px;
    // color: #cecece;
    // font-size: 14px;
    // p {
    //   font-size: 14px;
    //   line-height: 20px;
    // }
    // span {
    //   font-size: 12px;
    //   line-height: 16px;
    // }
  }
  .err-nowarp {
    ::v-deep .el-form-item__error {
      white-space: nowrap;
    }
  }
  .table-container {
    .is-error {
      ::v-deep .el-input__inner {
        border-color: #f56c6c;
      }
    }
  }
  .number-input {
    ::v-deep .el-input__inner {
      text-align: left;
    }
  }
  .number-input-prepend {
    // background-color: #f5f7fa;
    // color: #909399;
    // border-right: 1px solid #dcdfe6;
    // vertical-align: middle;
    // border-radius: 4px 0 0 4px;
    // display: inline-block;
    // height: 38px;
    // line-height: 38px;
    // width: 40px;
    // text-align: center;
    // position: absolute;
    // left: 1px;
    // top: 60%;
    // transform: translateY(-60%);
  }
  .table-number-input-prepend {
    // background-color: #f5f7fa;
    // color: #909399;
    // border-right: 1px solid #dcdfe6;
    // vertical-align: middle;
    // border-radius: 4px 0 0 4px;
    // display: inline-block;
    // height: 26px;
    // line-height: 26px;
    // width: 40px;
    // text-align: center;
    // position: absolute;
    // left: 1px;
    // top: 1px;
  }
  .prepend-padding {
    ::v-deep .el-input__inner {
      // padding-left: 55px;
    }
  }
  .is-error {
    color: #f56c6c;
    font-size: 12px;
  }
}
</style>
